/**
 * C4 — "Vocabulary". The three words this organisation's screens use for the
 * zoom levels above an invention.
 *
 * They come from the spine itself (components/spine/spineLevels.ts), which is
 * where the app's level labels actually live — not from a copy kept here, which
 * would be a second source of truth for the one thing this card exists to state.
 *
 * HONEST NOTE, and it is why the card says "the layout never does": the backend
 * has organisation-type packs (preferences/handler.py ORG_TYPE_PACKS) but none
 * of them carries level labels yet, so every organisation resolves to the same
 * three words today. When a pack supplies its own, this card reads them from the
 * same place and nothing else on any screen moves — which is the promise in the
 * sentence underneath.
 */
import { SPINE_LEVEL_LABEL } from '../spine'

const ROWS: { key: string; label: string; value: string }[] = [
  { key: 'bookLevelLabel', label: 'Book label', value: SPINE_LEVEL_LABEL.portfolio },
  { key: 'entityLevelLabel', label: 'Entity label', value: SPINE_LEVEL_LABEL.entity },
  { key: 'acrossLabel', label: 'Across label', value: SPINE_LEVEL_LABEL.across },
]

export default function OrgVocabularyPanel() {
  return (
    <div data-part="OrgVocabularyPanel" className="light-card p-4 lg:p-5">
      <h3 className="mb-2.5 text-[11px] font-bold uppercase tracking-wider text-iflow-700">
        Vocabulary
      </h3>
      {ROWS.map((row) => (
        <div
          key={row.key}
          className="flex items-center justify-between gap-2.5 border-t border-gray-100 py-2 text-[12.5px] first-of-type:border-t-0 first-of-type:pt-0.5"
        >
          <span className="text-gray-500">
            {row.label} <span className="font-mono text-[11px]">{row.key}</span>
          </span>
          <span className="whitespace-nowrap font-semibold text-gray-900">{row.value}</span>
        </div>
      ))}
      <p className="mt-2 text-[11.5px] leading-relaxed text-gray-500">
        Words adapt to the organisation&apos;s vocabulary pack — the layout never
        does. No screen prints a readable organisation-type name, because no
        token produces one.
      </p>
    </div>
  )
}
